module.exports = __webpack_public_path__ + "img/loader.432d0d9b.gif";